<template>
  <div>
    <CoverBg
      show-text
      title="About Us"
      text="STATECS is a data-driven organization set to
      improve the healthcare and medical system worldwide"
    />
    <b-container class="main-container content-padding-t-b-100">
      <BtnGroup />
      <Article
        :article="whyStatecs"
      />
      <div class="text-center">
        <img
          :src="photo1"
          alt="Fluid image"
          class="m-b-100"
        >
      </div>
      <Article
        :article="ourValues"
        class="m-b-100"
      />
      <Carousel class="m-b-100" />

      <div class="text-center">
        <img
          :src="photo2"
          alt="Fluid image"
          class="m-b-100"
        >
      </div>

      <MeetOurTeam />
    </b-container>
    <ScrollToTop />
    <CoverBg
      bg="cover-bg-page-bottom"
    />
  </div>
</template>

<script>
import CoverBg from '@/components/CoverBg';
import Article from '@/components/Article/Article';
import Carousel from '@/components/Carousel/Carousel';
import MeetOurTeam from '@/components/MeetOurTeam/MeetOurTeam';
import BtnGroup from '@/components/BtnGroup';
import ScrollToTop from '@/components/ScrollToTop';
import { whyStatecs, ourValues } from '@/constants/Article/articles';

export default {
  name: 'AboutUs',
  components: {
    BtnGroup,
    MeetOurTeam,
    Carousel,
    Article,
    CoverBg,
    ScrollToTop,
  },
  data() {
    return {
      whyStatecs,
      ourValues,
      photo1: '/assets/images/team/who_we_are_1.png',
      photo2: '/assets/images/team/who_we_are_2.png',
    };
  },
};
</script>
